/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (
  window.location.hostname !== 'localhost' &&
  window.location.hostname !== '127.0.0.1' &&
  process.env.NODE_ENV === 'production'
) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered() {
      // registration
      console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      // registration
      console.log('New content is downloading.')
      // const newWorker = registration.installing
      // newWorker.state

      // var refreshing

      // newWorker.addEventListener('statechange', () => {
      //   if (newWorker.state === 'activated') {
      //     if (refreshing) return
      //     window.location.reload()
      //     refreshing = true
      //   }
      // })

      //trackInstalling(reg.installing)
    },
    updated(registration) {
      // console.log('New content is available; please refresh.')
      // let confirmationResult = confirm(
      //   'A newer version of the SeoulSpice App exists. Do you want to reload the app now?'
      // )
      // if (confirmationResult)
      registration.waiting.postMessage({ action: 'skipWaiting' })
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
  // .then(registration => {
  //   console.log(registration)
  // })

  let refreshing
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    window.location.reload()
    refreshing = true
  })
}
